export * from './queries';

export const quotationKeys = {
  quotations: (accountId: string) => ['quotations', accountId],
  fileLink: (quotationId: string, locale: string) => ['quotationFile', quotationId, locale],
};
